(() => {
  const script = document.currentScript;
  const root = script && script.previousElementSibling;
  if (!root || !root.matches('[data-tan-salon-camera]') || root.dataset.salonCameraReady) return;

  root.dataset.salonCameraReady = 'true';

  const preview = root.querySelector('[data-salon-camera-preview]');
  const choices = Array.from(root.querySelectorAll('[data-salon-surface-choice]'));
  const range = root.querySelector('[data-salon-brightness]');
  const value = root.querySelector('[data-salon-brightness-value]');
  const resultHeading = root.querySelector('[data-salon-surface-heading]');
  const resultCopy = root.querySelector('[data-salon-surface-copy]');
  const resultList = root.querySelector('[data-salon-surface-list]');
  const portraitFrame = root.querySelector('.tan-salon-camera__portrait-frame');
  const signText = root.querySelector('.tan-salon-camera__sign > span:first-child');
  const reflectionText = root.querySelector('.tan-salon-camera__reflection');
  let fitFrame = 0;

  const measureTextWidth = (element) => {
    if (!element || !(element.textContent || '').trim()) return 0;
    const range = document.createRange();
    range.selectNodeContents(element);
    return range.getBoundingClientRect().width;
  };

  const fitTextToPortraitFrame = () => {
    fitFrame = 0;
    if (!portraitFrame || !signText) return;

    const availableWidth = portraitFrame.clientWidth * 0.84;
    if (availableWidth <= 0) return;

    signText.style.removeProperty('font-size');
    reflectionText?.style.removeProperty('font-size');

    const baseSize = Number.parseFloat(window.getComputedStyle(signText).fontSize);
    const reflectionBaseSize = reflectionText
      ? Number.parseFloat(window.getComputedStyle(reflectionText).fontSize)
      : 0;
    const naturalWidth = measureTextWidth(signText);
    if (!baseSize || !naturalWidth) return;

    const scale = Math.min(1, availableWidth / naturalWidth);
    if (scale >= 0.999) return;

    signText.style.fontSize = `${(baseSize * scale).toFixed(2)}px`;
    if (reflectionText && reflectionBaseSize) {
      reflectionText.style.fontSize = `${(reflectionBaseSize * scale).toFixed(2)}px`;
    }
  };

  const scheduleTextFit = () => {
    if (fitFrame) cancelAnimationFrame(fitFrame);
    fitFrame = requestAnimationFrame(fitTextToPortraitFrame);
  };

  const payloadFor = (choice) =>
    Array.from(root.querySelectorAll('[data-salon-surface-payload]')).find(
      (payload) => payload.dataset.salonSurfacePayload === choice.dataset.surfaceId,
    );

  const updateSurface = (choice) => {
    if (!choice || !preview) return;

    choices.forEach((candidate) => {
      const selected = candidate === choice;
      candidate.classList.toggle('is-active', selected);
      candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    preview.dataset.surface = choice.dataset.surfaceKey || 'mirror';
    if (resultHeading) resultHeading.textContent = choice.dataset.surfaceTitle || '';
    if (resultCopy) resultCopy.textContent = choice.dataset.surfaceNote || '';

    const payload = payloadFor(choice);
    const content = payload && payload.content.querySelector('[data-salon-surface-checklist]');
    if (resultList) resultList.innerHTML = content ? content.innerHTML : '';
  };

  const updateBrightness = () => {
    if (!range || !preview) return;
    const percentage = Number(range.value) || 65;
    const strength = Math.max(0.25, Math.min(1, percentage / 100));
    const blur = Math.round(8 + strength * 24);
    const largeBlur = Math.round(22 + strength * 54);

    preview.style.setProperty('--salon-glow-opacity', String(0.58 + strength * 0.42));
    preview.style.setProperty('--salon-glow-blur', `${blur}px`);
    preview.style.setProperty('--salon-glow-large-blur', `${largeBlur}px`);
    if (value) value.textContent = `${percentage}%`;
  };

  choices.forEach((choice) => choice.addEventListener('click', () => updateSurface(choice)));
  if (range) range.addEventListener('input', updateBrightness);

  updateSurface(choices.find((choice) => choice.classList.contains('is-active')) || choices[0]);
  updateBrightness();
  scheduleTextFit();

  const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleTextFit) : null;
  if (resizeObserver && portraitFrame) resizeObserver.observe(portraitFrame);
  window.addEventListener('resize', scheduleTextFit, { passive: true });
  window.addEventListener('orientationchange', scheduleTextFit, { passive: true });

  const fonts = document.fonts;
  if (fonts && fonts.ready) fonts.ready.then(scheduleTextFit);
  if (fonts && fonts.addEventListener) fonts.addEventListener('loadingdone', scheduleTextFit);

  const onSectionUnload = (event) => {
    if (!event.target || !event.target.contains(root)) return;
    resizeObserver?.disconnect();
    window.removeEventListener('resize', scheduleTextFit);
    window.removeEventListener('orientationchange', scheduleTextFit);
    if (fonts && fonts.removeEventListener) fonts.removeEventListener('loadingdone', scheduleTextFit);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
    if (fitFrame) cancelAnimationFrame(fitFrame);
  };

  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
